"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTokenValidationOnFocus = useTokenValidationOnFocus;
var _react = require("react");
var _reactRedux = require("react-redux");
var _validateUserToken = _interopRequireDefault(require("../actions/user/validateUserToken"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Custom hook for token validation on tab focus
function useTokenValidationOnFocus(enable) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var checkTokenValidity = (0, _react.useCallback)(function () {
    dispatch((0, _validateUserToken["default"])());
  }, [dispatch]);
  var onFocusChange = (0, _react.useCallback)(function () {
    if (document.visibilityState === 'visible') {
      // Check token validity when tab gains focus
      checkTokenValidity();
    }
  }, [checkTokenValidity]);
  (0, _react.useEffect)(function () {
    if (enable) {
      // Add event listener for visibility change
      document.addEventListener('visibilitychange', onFocusChange);

      // Cleanup function to remove event listener when component unmounts
      return function () {
        document.removeEventListener('visibilitychange', onFocusChange);
      };
    }
  }, [enable, onFocusChange]);
}